// @flow strict

import React from 'react';

import { useLanguageContext } from '~contexts/language-context';
import { SearchLightIcon } from '~components/icons/search-icon';

import * as styles from './search-field.module.less';

/**
 * Type for component properties
 */
type SearchFieldProps = {
  searchValue: string,
  onSearch: (value: string) => void,
};

/**
 * Search field with icon and input field.
 *
 * @param {SearchFieldProps} props - component properties
 *
 * @returns {Node}
 */
export const SearchField = ({ searchValue, onSearch }: SearchFieldProps) => {
  const { loc } = useLanguageContext();

  return (
    <div className={styles.searchField}>
      <SearchLightIcon className={styles.searchIcon} />
      <input
        className={styles.searchInput}
        placeholder={loc('_search_field_placeholder')}
        value={searchValue}
        onChange={(evt) => onSearch(evt.target.value)}
      />
    </div>
  );
};
